// LinkSubstringOembed.js
import { connect } from 'react-redux';
import LinkSubstringOembed from '../component/LinkSubstringOembed.jsx';
import fetchOembedData from '../action/fetchOembedData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import postMessageToApp from '../action/postMessageToApp.js';
import getAppUniversalLink from '../resource/getAppUniversalLink.js';

const mapStateToProps = (state, ownProps) => {
  const { url } = ownProps;
  const oembedSelectPath = ['oembed', url];
  const oembedData = getOperationData(state, ['oembed'], url);
  const isFetched = !!getNetworkingData(state, oembedSelectPath, 'isFetched');
  const isFetching = !!getNetworkingData(state, oembedSelectPath, 'isFetching');
  const shouldSkipFetch = isFetched || isFetching;
  return {
    oembedData,
    shouldSkipFetch,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchOembedData: ({ url, language }) =>
      dispatch(
        fetchOembedData({ url, language, maximumWidth: 60, maximumHeight: 60 })
      ),
    openUserProfileByWebViewPostMessage: ({ userId }) =>
      dispatch(
        postMessageToApp({
          message: 'actionUrl',
          messageArgs: [
            getAppUniversalLink({
              search: {
                view: 'user-profile',
                'user-id': userId,
              },
            }),
          ],
          fallbackRouteInWebApp: `/user/${userId}`,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkSubstringOembed);
